import store from '@/store';

// Routes
import myAccount from './route/my-account';
import administrators from './route/administrators';
import companies from './route/companies';
import courses from './route/courses';
import codes from './route/codes';
import invitations from './route/invitations';
import users from './route/users';
import exams from './route/exams';
import tags from './route/tags';

const CommonSidebar = () => import(/* webpackChunkName: "component.header" */ '@/components/Sidebar');
const CommonHeader = () => import(/* webpackChunkName: "component.header" */ '@/components/Header');
const CommonFooter = () => import(/* webpackChunkName: "component.header" */ '@/components/Footer');

export default [
  {
    name: 'login',
    path: '/login',
    component: () => import(/* webpackChunkName: "login" */ '@/views/Public/Login'),
    beforeEnter (from, to, next) {
      if (store.getters['administrator/me/isLoggedIn']) {
        return next(to.path);
      }
      return next();
    },
  },
  {
    path: '/',
    component: () => import('@/layout/Private'),
    children: [
      {
        path: '',
        name: 'dashboard',
        components: {
          sidebar: CommonSidebar,
          header: CommonHeader,
          footer: CommonFooter,
          default: () => import(/* webpackChunkName: "dashboard" */ '@/views/Dashboard'),
        },
        meta: {
          navigation: {
            link: {
              icon: 'desktop',
              label: 'Dashboard',
              to: {
                name: 'dashboard',
              },
            }
          }
        }
      },
      myAccount,
      administrators,
      companies,
      courses,
      codes,
      invitations,
      users,
      exams,
      tags
    ],
  },
];
